import styled from 'styled-components';
import { StyledNavLink } from '../NavLink/styled';

export const StyledNavList = styled.div`
  margin-bottom: ${(p) => p.isOpen && p.theme.space[3]};
  border-radius: ${(p) => p.theme.radii.pill};
  background-color: ${(p) => p.isOpen && p.theme.alias.light};
`;
